import { LitElement, html, css, nothing } from '~/lib/bn-lit-element';
import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import './bn-camera';
import './qr-layout';

import { context, actions } from './qr-context';

class QrScan extends LitElement {
  static get styles() {
    return css`
      .view-finder {
        background-color: var(--blue-10);
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
      }
    `;
  }

  render() {
    return html`
      <qr-layout>
        <div class="view-finder">
          <qr-camera @data=${this.onData}></qr-camera>
        </div>
        <div slot="actions">
          ${context.state.serialNumber ? html`
            <bn-button @click="${this.onCancel}">Cancel</bn-button>
          ` : nothing}
        </div>
      </qr-layout>
    `;
  }

  onData(e) {
    const { data } = e.detail;
    if (!data) {
      return;
    }

    const url = new URL(data);
    const serialNumber = url.searchParams.get('serialNumber');

    if (!serialNumber) {
      return;
    }

    store.dispatch(storeActions.navigate('/bins/qr', { serialNumber }));
    actions.clear({ serialNumber });
  }

  onCancel() {
    actions.home();
  }
}

window.customElements.define('qr-scan', QrScan);
